// React&NextJS
import React, { useState, useEffect } from 'react'
// Context&Auth
import { auth } from '../firebase/initFirebase'
import { useAuth } from './UserContext'
// Components
import SignUp from '../pages/sign-up'

//HOC used to create private routes
//Wrap around pages to make them private
const withAuth = (Component) => {
    const Auth = (props) => {
        const { user } = useAuth()

        const [, setIsBrowser] = useState(false)

        useEffect(() => {
            setIsBrowser(true)
        }, [])

        if (global.window !== undefined) {
            if (
                window.location.pathname === '/account/email-change' &&
                auth?.currentUser
            ) {
                return <Component {...props} />
            }
        }
        // Hér ef við viljum að notandi þurfi að staðfesta netfang
        // if (auth.currentUser && user?.emailVerified) {

        // breytti emailVerified í email
        if (auth.currentUser && user?.email) {
            //If logged in, display Component
            return <Component {...props} />
        }

        //If not, return the SignUp component
        return (
            <>
                <SignUp {...props} />
                {/* <CommonQuestions /> */}
            </>
        )
    }

    //getInitialProps:
    //enables server-side rendering in a page and allows you to do initial
    //data population, it means sending the page with the data already populated
    //from the server. This is especially useful for SEO.
    if (Component.getInitialProps) {
        Auth.getInitialProps = Component.getInitialProps
    }

    return Auth
}

export default withAuth
